import type { CSSProperties } from 'react';
import type { TurbanStyle } from '@/data/styles';

export function StyleVisual({
  style,
  className = '',
  imageClassName = '',
  imageOverride,
}: {
  style: TurbanStyle;
  className?: string;
  imageClassName?: string;
  imageOverride?: string;
}) {
  const image = imageOverride || style.image;
  if (image) {
    return <img src={image} alt={`${style.name} turban reference`} className={imageClassName} />;
  }

  return (
    <div
      className={`style-placeholder ${className}`}
      style={{ '--style-accent': style.accent, '--style-art': style.art } as CSSProperties}
      aria-label={`${style.name} fabric fold study placeholder`}
      role="img"
    >
      <span className="style-placeholder-fold fold-one" />
      <span className="style-placeholder-fold fold-two" />
      <span className="style-placeholder-fold fold-three" />
    </div>
  );
}